import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  canonicalUrl: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  jsonLd?: Record<string, unknown>;
}

const DEFAULT_OG_IMAGE = 'https://depanfenetres-lyon.fr/images/dfpro-hero-2026.jpg';

export default function SEOHead({ title, description, canonicalUrl, ogTitle, ogDescription, ogImage, jsonLd }: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const img = ogImage || DEFAULT_OG_IMAGE;
    setMeta('description', description);
    setMeta('og:title', ogTitle || title, true);
    setMeta('og:description', ogDescription || description, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:image', img, true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', ogTitle || title);
    setMeta('twitter:description', ogDescription || description);
    setMeta('twitter:image', img);

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) canonicalEl.setAttribute('href', canonicalUrl);

    if (jsonLd) {
      const existingScript = document.getElementById('page-jsonld');
      if (existingScript) existingScript.remove();
      const script = document.createElement('script');
      script.id = 'page-jsonld';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
      return () => { document.getElementById('page-jsonld')?.remove(); };
    }
  }, [title, description, canonicalUrl, ogTitle, ogDescription, ogImage, jsonLd]);

  return null;
}
